import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';
interface Props {
  isMinWidth?: number;
  isActive?: boolean;
  isModal?: boolean;
}

export const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;
  ${mobile_xl(css`
    position: unset;
  `)}
`;

export const Trigger = styled.div`
  cursor: pointer;
  display: inline-block;
  &.activeClassName {
    background-color: var(--background-active-navbar);
    border-radius: var(--border-radius-8);
    svg path {
      fill: var(--text-primary);
    }
    &:hover {
      background-color: var(--background-active-navbar);
      button {
        background-color: var(--background-active-navbar);
      }
    }
  }
`;

export const DropdownContent = styled.div<Props>`
  display: flex;
  flex-direction: column;
  padding: var(--space-12);
  margin-top: var(--space-4);
  gap: var(--space-12);
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-modal);
  border-radius: var(--border-radius-12);
  position: absolute;
  top: 100%;
  right: 0;
  z-index: var(--z-index-header);
  ${(props: Props) =>
    props.isMinWidth &&
    css`
      min-width: ${props.isMinWidth}px;
    `}
  ${mobile_xl(css<Props>`
    ${({ isModal }) =>
      isModal &&
      css`
        position: unset;
        margin-top: var(--space-0);
        background: unset;
        border: unset;
        box-shadow: unset;
        border-radius: unset;
      `}
  `)}
`;
